import { useState } from "react";

const questions = [
  {
    question: "How does your skin feel at the end of the day?",
    options: [
      { answer: "Oily and shiny", type: "oily" },
      { answer: "Dry or tight", type: "dry" },
      { answer: "Oily in T-zone, dry elsewhere", type: "combination" },
      { answer: "Comfortable and balanced", type: "normal" },
    ],
  },
  {
    question: "How often do you get breakouts?",
    options: [
      { answer: "Very often", type: "acne-prone" },
      { answer: "Sometimes during stress or cycle", type: "combination" },
      { answer: "Rarely", type: "normal" },
      { answer: "I get more dry patches", type: "dry" },
    ],
  },
  {
    question: "How visible are your pores?",
    options: [
      { answer: "Very visible", type: "oily" },
      { answer: "Not really visible", type: "dry" },
      { answer: "Visible in some spots", type: "combination" },
      { answer: "Hardly notice them", type: "normal" },
    ],
  },
  {
    question: "How does your skin react to new products?",
    options: [
      { answer: "Breaks out or gets irritated", type: "acne-prone" },
      { answer: "Feels dry or flaky", type: "dry" },
      { answer: "No problem usually", type: "normal" },
      { answer: "Sometimes oily or breakout", type: "oily" },
    ],
  },
  {
    question: "What’s your main skincare goal?",
    options: [
      { answer: "Reduce oil and shine", type: "oily" },
      { answer: "Soothe dryness or redness", type: "dry" },
      { answer: "Prevent breakouts", type: "acne-prone" },
      { answer: "Just keep skin healthy", type: "normal" },
    ],
  },
];

export default function Quiz() {
  const [step, setStep] = useState(0);
  const [scores, setScores] = useState({});
  const [finished, setFinished] = useState(false);

  const total = questions.length;

  const handleSelect = (type) => {
    setScores((prev) => ({ ...prev, [type]: (prev[type] || 0) + 1 }));
    const next = step + 1;
    if (next < total) {
      setStep(next);
    } else {
      setFinished(true);
    }
  };

  const resetQuiz = () => {
    setStep(0);
    setScores({});
    setFinished(false);
  };

  const getResult = () => {
    const sorted = Object.entries(scores).sort((a, b) => b[1] - a[1]);
    return sorted[0]?.[0] || "normal";
  };

  return (
    <div className="bg-[#fef8f5]">
      {/* Header */}
      <div
        className="relative h-[40vh] bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://img.freepik.com/free-photo/women-celebrating-all-skin-tones_23-2149179655.jpg?t=st=1745428574~exp=1745432174~hmac=f97edf12104d7897cce11491f2c7b044897650966f96ad5be88a6341b7f6fa3d&w=996')",
        }}
      >
        <div className="absolute inset-0 bg-[#fef8f5] opacity-90" />
        <div className="absolute inset-0 flex items-center justify-center">
          <h1 className="text-4xl font-serif font-bold text-[#7a6e5f]">
            Find Your Skin Type
          </h1>
        </div>
      </div>

      {/* Quiz Body */}
      <div className="py-12 px-4 text-[#7a6e5f]">
        <div className="max-w-xl mx-auto">
          <h2 className="text-xl font-semibold text-center mb-6">
            Not sure what your skin needs? Take our quick quiz.
          </h2>

          {!finished ? (
            <>
              {/* Progress */}
              <div className="mb-4">
                <div className="h-2 bg-[#f5eee6] rounded-full">
                  <div
                    className="h-full bg-[#809080] transition-all duration-300"
                    style={{ width: `${((step + 1) / total) * 100}%` }}
                  />
                </div>
                <p className="text-sm text-right mt-1">
                  {step + 1} / {total}
                </p>
              </div>

              {/* Question */}
              <div className="mb-6">
                <p className="text-lg font-medium mb-4">
                  {questions[step].question}
                </p>
                <div className="space-y-3">
                  {questions[step].options.map((opt, i) => (
                    <button
                      key={i}
                      onClick={() => handleSelect(opt.type)}
                      className="w-full text-left bg-[#f5eee6] hover:bg-[#e8dfd3] px-4 py-3 rounded-md transition-colors"
                    >
                      {opt.answer}
                    </button>
                  ))}
                </div>
              </div>
            </>
          ) : (
            <div className="text-center mt-8">
              <h2 className="text-xl font-semibold mb-2">Your skin type is:</h2>
              <p className="text-[#809080] text-2xl capitalize font-bold mb-4">
                {getResult()}
              </p>
              <p className="mb-6">
                Based on your answers, we recommend skincare that works best for{" "}
                <span className="font-medium">{getResult()}</span> skin.
              </p>
              <button
                onClick={resetQuiz}
                className="bg-[#809080] text-white px-6 py-3 rounded-md hover:bg-[#6d7d6d] transition"
              >
                Retake Quiz
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
